import React, { Component } from "react";
import { Tabs, Radio, Divider, Spin } from "antd";
import { connect } from "dva";
import Container from "../../../../../components/Container";
import PointRankList from "./List";
import {
  schoolStuClassRank,
  schoolStuPersonalRank,
  schoolTeaPersonalRank,
  bureauStuClassRank,
  bureauStuPersonalRank,
  bureauStuSchoolRank,
  schoolStuSchoolRank,
  bureauTeaPersonalRank,
  bureauTeaSchoolRank
} from "../../../../../services/activitySign/dataStatistic/pointRank";
import styles from "./index.less";

const { TabPane } = Tabs;

@connect(({ user, activityGlobal }) => ({
  ...user,
  spinProps: activityGlobal.spinProps
}))
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nowRadioValue: "student",
      nowTabKey: "1",
      modalVisible: false,
      haveClassList: false
    };
  }

  // radio切换的回调
  handleRadioChange = e => {
    this.setState({
      nowRadioValue: e.target.value,
      nowTabKey: "1",
      haveClassList: false
    });
  };

  // tabs切换的回调
  handleTabChange = tabKey => {
    const { currentUser, dispatch } = this.props;
    const { orgType } = currentUser || {};
    if (tabKey === "2" && orgType === "school") {
      dispatch({
        type: "activityGlobal/fetchSchoolClassList",
        callback: () => {
          this.setState({
            nowTabKey: tabKey,
            haveClassList: true
          });
        }
      });
    } else {
      this.setState({
        nowTabKey: tabKey,
        haveClassList: false
      });
    }
  };

  // 控制子组件的规则介绍的modal是否展示
  handleShowModal = visible => {
    this.setState({
      modalVisible: visible
    });
  };

  // 学生榜单的tabs
  renderStudentTabs = () => {
    const { nowTabKey } = this.state;
    const { currentUser } = this.props;
    const { orgType } = currentUser || {};
    const isSchool = orgType === "school";
    return (
      <Tabs activeKey={nowTabKey} onChange={this.handleTabChange} type="card">
        <TabPane tab={isSchool ? "本校榜单" : "学校榜单"} key="1">
          {nowTabKey === "1" &&
            this.renderPointRankList(
              isSchool ? schoolStuSchoolRank : bureauStuSchoolRank,
              isSchool ? "schoolStuSchool" : "bureauStuSchool"
            )}
        </TabPane>
        <TabPane tab="班级榜单" key="2">
          {nowTabKey === "2" &&
            this.renderPointRankList(
              isSchool ? schoolStuClassRank : bureauStuClassRank,
              isSchool ? "schoolStuClass" : "bureauStuClass"
            )}
        </TabPane>
        <TabPane tab="个人榜单" key="3">
          {nowTabKey === "3" &&
            this.renderPointRankList(
              isSchool ? schoolStuPersonalRank : bureauStuPersonalRank,
              isSchool ? "schoolStuPersonal" : "bureauStuPersonal"
            )}
        </TabPane>
      </Tabs>
    );
  };

  // 老师榜单的tabs
  renderTeacherTabs = () => {
    const { nowTabKey } = this.state;
    const { currentUser } = this.props;
    const { orgType } = currentUser || {};
    return orgType === "county" ? (
      <Tabs activeKey={nowTabKey} onChange={this.handleTabChange} type="card">
        <TabPane tab="学校榜单" key="1">
          {nowTabKey === "1" &&
            this.renderPointRankList(bureauTeaSchoolRank, "bureauTeaSchool")}
        </TabPane>
        <TabPane tab="个人榜单" key="2">
          {nowTabKey === "2" &&
            this.renderPointRankList(
              bureauTeaPersonalRank,
              "bureauTeaPersonal"
            )}
        </TabPane>
      </Tabs>
    ) : (
      this.renderPointRankList(schoolTeaPersonalRank, "schoolTeaPersonal")
    );
  };

  // 子表格
  renderPointRankList = (request, nowRankType) => {
    const { modalVisible, nowRadioValue, haveClassList } = this.state;
    const { currentUser } = this.props;
    const { orgType } = currentUser;
    return (
      <PointRankList
        modalVisible={modalVisible}
        handleShowModal={this.handleShowModal}
        nowRadioValue={nowRadioValue}
        orgType={orgType}
        request={request}
        nowRankType={nowRankType}
        haveClassList={haveClassList}
      />
    );
  };

  render() {
    const { nowRadioValue } = this.state;
    const { spinProps } = this.props;
    const containerProps = {
      breStates: 1,
      defaultPadding: 1
    };
    return (
      <Container {...containerProps}>
        <div className={styles.root}>
          <Spin {...spinProps}>
            <Radio.Group
              onChange={this.handleRadioChange}
              style={{ marginBottom: 16 }}
              value={nowRadioValue}
              buttonStyle="solid"
            >
              <Radio.Button value="student">学生榜单</Radio.Button>
              <Radio.Button value="teacher">教师榜单</Radio.Button>
            </Radio.Group>
            {nowRadioValue === "student" && this.renderStudentTabs()}
            {nowRadioValue === "teacher" && this.renderTeacherTabs()}
          </Spin>
        </div>
      </Container>
    );
  }
}

export default index;
